<template>
  <ejs-pager
    :id="id"
    :click="onPagerClick"
    :drop-down-changed="dropDownChanged"
    :current-page="paging.page"
    :page-size="paging.pageSize"
    :page-count="paging.pageCount"
    :total-records-count="totalRecords"
    :page-sizes="currentPageSizes"
    class="e-gridpager"
  />
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    paging: {
      type: Object,
      required: true
    },
    pageSizes: {
      type: Array
    },
    onPagerClick: Function,
    dropDownChanged: Function
  },
  computed: {
    currentPageSizes () {
      return this.pageSizes ?? this.paging.pageSizes
    },
    ...mapGetters({
      isLoading: 'getLoadingStatus'
    }),
    totalRecords () {
      return this.paging.totalRecords
    }
  },
  mounted () {
    this.$helpers.setEjsPager(this.id)
  }
}
</script>
<style scoped  lang="scss">
  .e-icons {
    color: #00ffff;
    font-size: 26px;
  }
</style>
